const captchaPublicKey = process.env.REACT_APP_CAPTCHA_PUBLIC_KEY
const basename = "/app"

// Both are injected at build time by .forgejo/workflows/auth-repoflow-app.yml
// from SSM (/${env}/auth-repoflow/{authDomain,projectDomainId}). Read through
// here rather than off process.env at the point of use, so every consumer sees
// the same value and the build-time contract lives in one file.
const authDomain = process.env.REACT_APP_AUTH_DOMAIN
const projectDomainId = process.env.REACT_APP_PROJECT_DOMAIN_ID

// CloudWatch RUM. Injected at build time by .forgejo/workflows/*-app.yml from
// the outputs of the ${env}-repoflow-system-observability-stack. All three are
// undefined in local dev, which leaves RUM inert — see
// @repoflow/components/observability.
const rum = {
    applicationId: process.env.REACT_APP_RUM_APP_MONITOR_ID,
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_RUM_REGION,
    // Baked from the app monitor's SessionSampleRate. The client samples on
    // its own side, so without this every session is recorded regardless of
    // what the monitor says. Absent or unparseable falls back to the client
    // default (1) — only reachable when RUM is inert anyway.
    sessionSampleRate: Number.isFinite(parseFloat(process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE))
        ? parseFloat(process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE)
        : undefined,
}

export {
    captchaPublicKey,
    basename,
    authDomain,
    projectDomainId,
    rum
}
